module.exports = __webpack_public_path__ + "img/tree_left_layout_icon.c75a64ab.svg";